<app-not-authorized-notice has="deviceManagement"></app-not-authorized-notice>

<div class="column content-container" [appHasSystemCapability] has="deviceManagement">
	<div class="content-container-header mat-h3" i18n="@@addDeviceGroup-groupName">Group Name</div>

	<mat-divider></mat-divider>

	<div class="content-container-body column spacing-24">
		<div class="row spacing-24">
			<div class="column-double">
				<mat-form-field subscriptSizing="dynamic" appearance="outline">
					<mat-label i18n="@@addDeviceGroupName-groupName">Group Name</mat-label>
					<input
						matInput
						[(ngModel)]="editDeviceGroup.name"
						(ngModelChange)="onNameChanged($event)"
						data-automation-id="group-name-input"
						required
					/>
				</mat-form-field>
				@if (!nameIsValid) {
					<h4 style="color: red" i18n="addDeviceGroupName-nameTaken" data-automation-id="group-name-error">
						Device Group name already taken
					</h4>
				}
			</div>
			<div class="column"></div>
		</div>
	</div>
</div>
